import { IndentService } from '@gtpl/shared-services/raw-material-procurement';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { VehicleAssignmentAdapter } from './dto/vehicle-assignment-adapter';
import { VehicleAssignmentController } from './vehicle-assignment.controller';
import { VehicleAssignment } from './vehicle-assignment.entity';
import { VehicleAssignmentService } from './vehicle-assignment.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([VehicleAssignment]),
  ],
  controllers: [VehicleAssignmentController],
  providers: [VehicleAssignmentService,VehicleAssignmentAdapter,ApplicationExceptionHandler,IndentService]
})
export class VehicleAssignmentModule {}
